import {MenuItem, Select, SelectProps, Typography} from "@mui/material";
import {forwardRef} from "react";

interface PrimarySelectProps extends SelectProps {
}

export function PrimarySelectItem({children, ...props}: any) {
    return (
        <MenuItem {...props}>
            <Typography fontSize={13}>
                {children}
            </Typography>
        </MenuItem>
    )
}

const PrimarySelect = forwardRef(({children, ...props}: PrimarySelectProps, ref) => {
    return (
        <Select
            ref={ref}
            {...props}
            size="small"
            inputProps={{
                sx: {
                    backgroundColor: 'white',
                    fontSize: 13
                }
            }}
            sx={{
                height: 35.69,
                fontSize: 13,
                borderRadius: 0
            }}
        >
            {children}
        </Select>
    )
})

export default PrimarySelect